import localforage from "localforage";

class Planning {
    static daysFR(dayEN){
        if(dayEN === "Mon"){
            return "Lundi";
        }else if(dayEN === "Tue"){
            return "Mardi";
        }else if(dayEN === "Wed"){
            return "Mercredi";
        }else if(dayEN === "Thu"){
            return "Jeudi";
        }else if(dayEN === "Fri"){
            return "Vendredi";
        }else if(dayEN === "Sat"){
            return "Samedi";
        }else if(dayEN === "Sun"){
            return "Dimanche";
        }else{
            return dayEN;
        }
    }

    static monthsFR(intMonth){
        if(intMonth === 0){
            return "Janvier";
        }else if(intMonth === 1){
            return "Février";
        }else if(intMonth === 2){
            return "Mars";
        }else if(intMonth === 3){
            return "Avril";
        }else if(intMonth === 4){
            return "Mai";
        }else if(intMonth === 5){
            return "Juin";
        }else if(intMonth === 6){
            return "Juillet";
        }else if(intMonth === 7){
            return "Août";
        }else if(intMonth === 8){
            return "Septembre";
        }else if(intMonth === 9){
            return "Octobre";
        }else if(intMonth === 10){
            return "Novembre";
        }else if(intMonth === 11){
            return "Décembre";
        }else{
            return intMonth;
        }
    }

    static getNotifications(callback){
        localforage
            .getItem('parameters')
            .then(parameters => {
                callback(JSON.parse(parameters));
            })
            .catch(err => {
            })
    }

}

export default Planning



// WEBPACK FOOTER //
// ./src/js/models/Planning.js